import { c as _c } from "react/compiler-runtime";
import ArrowLeftIcon from '@precis-digital/kurama/icons/ArrowLeftIcon';
import Button from '@precis-digital/kurama/Button';
import SwitchIcon from '@precis-digital/kurama/icons/SwitchIcon';
import { type ReactElement } from 'react';
import { type TFunction } from 'shared/translations';
const BUTTON_VARIANT_TEXT = 'text' as const;
interface FlyoutTopLeftAdornmentProps {
  isAdminWorkspaceProfile: boolean;
  isUserProfile: boolean;
  isSwitchWorkspace: boolean;
  isNotifications: boolean;
  onBackToOverview: () => void;
  onSwitchWorkspace: () => void;
  t: TFunction;
}
type FlyoutTopLeftAdornmentVisibilityProps = Pick<FlyoutTopLeftAdornmentProps, 'isAdminWorkspaceProfile' | 'isUserProfile' | 'isSwitchWorkspace' | 'isNotifications'>;
export const shouldShowFlyoutTopLeftAdornment = ({
  isAdminWorkspaceProfile,
  isUserProfile,
  isSwitchWorkspace,
  isNotifications
}: FlyoutTopLeftAdornmentVisibilityProps): boolean => isAdminWorkspaceProfile || !isUserProfile && !isSwitchWorkspace && !isNotifications;
const FlyoutTopLeftAdornment = t0 => {
  const $ = _c(12);
  const {
    isAdminWorkspaceProfile,
    isUserProfile,
    isSwitchWorkspace,
    isNotifications,
    onBackToOverview,
    onSwitchWorkspace,
    t
  } = t0;
  if (!shouldShowFlyoutTopLeftAdornment({
    isAdminWorkspaceProfile,
    isUserProfile,
    isSwitchWorkspace,
    isNotifications
  })) {
    return null;
  }
  if (isAdminWorkspaceProfile) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <ArrowLeftIcon />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== t) {
      t2 = t("backToOverview");
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== onBackToOverview || $[4] !== t2) {
      t3 = <Button variant={BUTTON_VARIANT_TEXT} onClick={onBackToOverview} leftIcon={t1}>{t2}</Button>;
      $[3] = onBackToOverview;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SwitchIcon />;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t) {
    t2 = t("switchWorkspace");
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== onSwitchWorkspace || $[10] !== t2) {
    t3 = <Button variant={BUTTON_VARIANT_TEXT} onClick={onSwitchWorkspace} leftIcon={t1}>{t2}</Button>;
    $[9] = onSwitchWorkspace;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default FlyoutTopLeftAdornment;